import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/system';

interface JobSummaryCardStatProps {
  isEmphasized?: boolean;
  primaryText: string;
  secondaryTexts?: string[];
  sx?: SxProps;
  title: string;
}

export default function JobSummaryCardStat({
  isEmphasized = false,
  primaryText,
  secondaryTexts,
  title,
  sx,
}: JobSummaryCardStatProps) {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'grid', alignContent: 'start', ...sx }}>
      <Typography variant="body2" sx={{ color: theme.brandV2.colors.treadGray2 }}>
        {title}
      </Typography>

      <Typography variant="h6" sx={isEmphasized ? { fontWeight: 700 } : undefined}>
        {primaryText}
      </Typography>

      {secondaryTexts?.map((text, index) => (
        <Typography
          key={index}
          variant="caption"
          sx={{ color: theme.brandV2.colors.treadGray2, fontWeight: 500 }}
        >
          {text}
        </Typography>
      ))}
    </Box>
  );
}
